<template>
    <div>
        <md-button
            title="Edit run details"
            class="header-button"
            @click.stop="showEditRunDetails(run)"
        >
            <span>Edit</span>
        </md-button>
    </div>
</template>


<script>
import { GeneralMixin } from '@/mixins/GeneralMixin';
import UpdateRunModal from '@/pages/Trips/Modals/UpdateRunModal';

export default {
    name: 'RunStatusButton',
    mixins: [GeneralMixin],
    props: {
        run: {
            type: Object,
            default: () => {}
        }
    },
    methods: {
        showEditRunDetails(run) {           
            if (run) {
                const runModel = {
                    ...run,
                    runCustomerId: run.runCustomerId ?? run.customerId,
                    runCustomerName: run.runCustomerName ?? run.customerName,
                    runRateGroupId: run.runRateGroupId ?? run.rateGroupId,
                    runRateGroupName: run.runRateGroupName ?? run.rateGroupName
                };

                this.$modal.show(UpdateRunModal, { run: runModel, teamRegionId: null })
                    .then(async (response) => {
                        if(response.code === 'ok') {
                            Object.assign(run, {
                                customerName: response.customerName,
                                rateGroupName: response.rateGroupName,
                                customerId: response.customerId,
                                rateGroupId: response.rateGroupId
                            });
                        }
                    });
            }
        }
    }
};
</script>
